import React from 'react';
import { connect } from 'react-redux';
import { timeFormat as format } from 'd3';
import { timeMinute } from 'd3-time';
import ReactPaginate from 'react-paginate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import listPortfolios from '../../actions/list-portfolios';
import deletePortfolio from '../../actions/delete-portfolio';
import favoritePortfolio from '../../actions/favorite-portfolio';

import { LOAD_PORTFOLIO } from '../../actions/actions.js';

import loadingIndicator from '../../assets/local-loading.gif';
import Favorite from './Favorite';

import './History.css';

const mapStateToProps = state => ({
  history: state.history,
  pendingDeletePortfolio: state.pendingDeletePortfolio,
  pendingFavoritePortfolio: state.pendingFavoritePortfolio,
  investmentGoalOptions: state.investmentGoalOptions,
  fundData: state.fundData
});

const mapDispatchToProps = dispatch => ({
  listPortfolios: () => dispatch(listPortfolios),
  loadPortfolio: portfolio => dispatch({ type: LOAD_PORTFOLIO, portfolio }),
  deleteSavedPortfolio: id => dispatch(deletePortfolio(id)),
  favoriteSavedPortfolio: (id, value) => dispatch(favoritePortfolio(id, value)),
});

class History extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      currPage: 0,
      numPerPage: 5,
    };

    this.paginate = this.paginate.bind(this);
  }

  componentDidMount() {
    this.props.listPortfolios();
  }

  paginate({ selected }) {
    this.setState(Object.assign({}, this.state, {
      currPage: selected,
    }));
  }

  render() {
    const {
      history,
      pendingDeletePortfolio,
      pendingFavoritePortfolio,
      width,
      investmentGoalOptions,
      TEXT,
    } = this.props;
    const {
      deleteSavedPortfolio,
      favoriteSavedPortfolio,
      loadPortfolio,
    } = this.props;

    const {
      currPage,
      numPerPage,
    } = this.state;

    const min = currPage * numPerPage;
    const max = min + numPerPage;

    const formatDate = width < 729 ? format('%m-%d') : format('%Y-%m-%d');
    const formatTime = format('%I:%M:%S %p');

    const loadPortfolioAndJump = (row) => {
      //window.scroll(0, document.querySelector('.portfolio-configuration:not(.out-of-focus)').getBoundingClientRect().top + window.pageYOffset);
      window.document.getElementById('fund-selector').scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      loadPortfolio(row);
    }

    if ((!this.props.fundData.fundsToCompare || this.props.fundData.fundsToCompare.length === 0) && !this.props.fundData.loadingMessage) {

      let historyToShow = []
      let pageCount = 1
      if (Array.isArray(history.portfolios) && history.portfolios.length) {
        historyToShow = history.portfolios.slice(min, max);
        pageCount = Math.ceil(history.portfolios.length / numPerPage);
      }

      return (

        <div className="history">
          <br />

          {typeof history.portfolios === 'string' ?
            <div className='loading-spinner'>
              <FontAwesomeIcon icon="circle-notch" size="4x" style={{ color: '#050139' }} spin />
            </div> : null}
          <h2></h2>
          {!Array.isArray(history.portfolios) || !history.portfolios.length
            ? null
            : <div>
              <h2>PORTFOLIO ANALYSIS HISTORY</h2>
              <div className="table">
                <table id="history-table" className="table table-sm ">
                  <thead>

                    <tr>
                      <th scope="col" className='favorite-column' ></th>
                      <th scope="col" className='left ' >Portfolio Name</th>
                      <th scope="col" className='center' >Date</th>
                      <th scope="col" className='center hidden-xs' >Time</th>
                      <th scope="col" className='left ' >Tickers</th>
                      {/* <th /> */}
                    </tr>


                  </thead>
                  <tbody>
                    {historyToShow.map(row => (
                      <tr key={row.id} onClick={() => loadPortfolioAndJump(row)}>
                        {/* <tr key={row.id} > */}
                        <td className="favorite-column">
                          <Favorite
                            value={
                              // pendingFavoritePortfolio[row.id]
                              //   ? !row.favorite
                              //   : row.favorite
                              row.favorite
                            }
                          // onClick={event => {
                          //   favoriteSavedPortfolio(row.id, !row.favorite);
                          //   event.stopPropagation();
                          // }}
                          />
                        </td>
                        <td className='left '>
                          {!row.name ? '' : row.name.split(' ')
                            .reduce((t, v, i) => {
                              if (i < 2) {
                                return [t[t.length - 1] + ' ' + v];
                              } else if (t[t.length - 1].length < 32) {
                                return [...t.slice(0, t.length - 1), t.slice(t.length - 1) + ' ' + v];
                              } else {
                                return [...t, 0, v];
                              }
                            }, [''])
                            .map((o, i) => o !== 0 ? <span key={o}>{o}</span> : <br key={i} />)
                          }
                        </td>
                        <td className='center'>
                          {row.runDate && formatDate(
                            timeMinute.offset(
                              new Date(row.runDate),
                              -1 * (new Date().getTimezoneOffset())
                            )
                          )}
                        </td>
                        <td className="hidden-xs center">
                          {row.runDate && formatTime(
                            timeMinute.offset(
                              new Date(row.runDate),
                              -1 * (new Date().getTimezoneOffset())
                            )
                          )}
                        </td>

                        <td className="ticker left">
                          {row.holdings[0].tickers
                            .map(v => <span key={v}>{v}</span>)
                            .reduce((t, v, i) =>
                              [t, ', ', (i % 7 === 0 ? <br key={i} /> : ''), v])}
                        </td>
                        {/* <td className="remove">
                        {pendingDeletePortfolio[row.id]
                          ? <img src={loadingIndicator} alt="Pending" />
                          : <div
                              className="action"
                              onClick={event => {
                                event.stopPropagation();
                                deleteSavedPortfolio(row.id);
                              }}
                            >
                              ✕
                            </div>}
                      </td> */}
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className='row-pagination'>
                  {/* Show pagination */}
                  <ReactPaginate
                    previousLabel={<FontAwesomeIcon icon="chevron-left" size="xs" />}
                    nextLabel={<FontAwesomeIcon icon="chevron-right" size="xs" />}
                    pageCount={pageCount}
                    breakLabel={'...'}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={3}
                    onPageChange={this.paginate}
                    containerClassName={'pagination'}
                    pageClassName={'page-item'}
                    pageLinkClassName={'page-item'}
                    previousClassName={'page-item'}
                    previousLinkClassName={'pageLink'}
                    nextClassName={'page-item'}
                    nextLinkClassName={'pageLink'}
                    activeClassName={'active'}
                    disabledClassName={'disabled'}
                    breakLinkClassName={'break'}
                  />
                </div>

              </div>
            </div>}
        </div>
      );
    } else {
      return null;
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(History);
